module.exports = __webpack_public_path__ + "static/media/location_on.25bcaf3e.svg";